import { ISubscriptionsItem, Web3Address } from 'multirpc-sdk';

import { MultiService } from 'modules/api/MultiService';
import { RequestType, web3Api } from 'store/queries';
import { createNotifyingQueryFn } from 'store/utils/createNotifyingQueryFn';

interface IFetchMyBundlesParams {
  group?: Web3Address;
}

// The endpoint name is listed in endpointsSerializedByParams constant
// in packages/protocol/src/store/queries/index.ts file.
// If the name has changed it should be reflected there as well.
export const {
  endpoints: { fetchMyBundles },
  useFetchMyBundlesQuery,
} = web3Api.injectEndpoints({
  endpoints: build => ({
    fetchMyBundles: build.query<ISubscriptionsItem[], IFetchMyBundlesParams>({
      providesTags: [RequestType.MyBundles],
      queryFn: createNotifyingQueryFn(async ({ group }) => {
        const api = MultiService.getService().getAccountingGateway();

        const data = await api.getMyBundles(group);

        return { data };
      }),
    }),
  }),
  overrideExisting: true,
});
